import { IHostActions } from '@makemydeal/dr-activities-open-deal-v2';
import { bootstrapSharedActionCreators } from '@makemydeal/dr-shared-store';
import { MANAGER_VIEW_APP_PREFIX } from '@makemydeal/dr-shared-ui-utils';

export const hostActions: IHostActions = {
    navigateToDashboard: () => {
        return (dispatch: any) => {
            dispatch(bootstrapSharedActionCreators.fetchBootstrapData(MANAGER_VIEW_APP_PREFIX, { loadDraftScenario: true }));
        };
    }
};
